const API_URL = process.env.VUE_APP_API_BASE_URL;
// import axios from "@/axios"; 
import axios from "@/axios"; 
export default {
    async getOltVpn(pppoe_user,olt_ip) {
  
      try {
        const response = await axios.get(API_URL+`/pppoe_user/${pppoe_user}/?olt_ip=${olt_ip}`);
        return response.data;
      } catch (error) {
        console.error("Error retrieving olt vpn:", error);
        throw error; 
      }
    },

    
  };
